export var mainContainerMinWidthPx = 894;
export var mainContainerMaxWidthPx = 1254;